export default "__VITE_ASSET__DVCsmAFH__"